<template>
  <div id="page-user-list">
    <div class="flex flex-wrap items-center">
      <!-- ITEMS PER PAGE -->
      <div class="flex-grow">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="PlusCircleIcon"
              icon-right
              :statistic="currency(dataTransaction.sum[0].totalWinlose)"
              statisticTitle="WIN/LOSE"
              color="warning"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="MinusCircleIcon"
              icon-right
              :statistic="currency(dataTransaction.sum[0].totalTurn)"
              statisticTitle="TURNOVER"
              color="danger"
            />
          </div>
        </div>

        <vx-card title="Filter">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <label class="vs-input--label">เบอร์โทร</label>
              <vs-input class="w-full mt-4" type="text" v-model="phone" />
              <br />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <label class="vs-input--label">ยูสเข้าเล่น</label>
              <vs-input class="w-full mt-4" type="text" v-model="username" />
              <br />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <label class="vs-input--label">Start Date</label>
              <flat-pickr
                class="w-full mt-4"
                v-model="startDate"
                :config="config"
              />
              <br />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <label class="vs-input--label">End Date</label>
              <flat-pickr
                class="w-full mt-4"
                v-model="endDate"
                :config="config"
              />
              <br />
            </div>

          </div>
          <vs-button class="mr-2" color="success" @click="getDataTransaction()">Search</vs-button>
          <vs-button color="primary" @click="clearSearchBox()">Clear</vs-button>
        </vx-card>
        <br />

        <vx-card title="Result">
          <vs-table stripe max-items="20" pagination :data="dataTransaction.transaction" search>
            <template slot="thead">
              <vs-th>ยูสเข้าเล่น</vs-th>
              <vs-th>วันที่</vs-th>
              <vs-th>ได้/เสีย</vs-th>
              <vs-th>เทรินโอเวอร์</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.username" class="text-danger"><router-link :to="`/member/${tr.username}`">{{tr.username}}</router-link></vs-td>
                <vs-td :data="tr.date">
                  {{ moment( tr.date ).format("YYYY-MM-DD")}}
                </vs-td>
                <vs-td :data="tr.turnover">
         {{ tr.turnover }}

                </vs-td>
                <vs-td :data="tr.winloss">
                  <div v-if="tr.winloss > 0" class="text-success">
                    {{ tr.winloss }}
                  </div>
                  <div v-else class="text-danger">
                    {{ tr.winloss }}
                  </div>
                </vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import axios from '../../../axios'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    StatisticsCardLine,
    vSelect,
    flatPickr
  },
  data () {
    return {
      phone : '',
      username : '',
      league : '',
      gruop: '',
      endDate: this.moment().format('YYYY-MM-DD HH:mm:ss'),
      startDate: this.moment()
        .subtract(1, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
      dataTransaction: []
    }
  },
  async mounted () {
    await this.getDataTransaction()
  },
  methods: {
    clearSearchBox () {
      this.endDate = this.moment().format('YYYY-MM-DD HH:mm:ss')
      this.startDate = this.moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.phone = ''
      this.username = ''
    },
    async getDataTransaction () {
      axios
        .post('/reportwinlose/transaction', {
          startDate : this.startDate,
          endDate : this.endDate,
          phone : this.phone,
          username : this.username
        })
        .then(response => (this.dataTransaction = response.data))
        .catch()
    },
    currency (amount) {
      amount = (amount * 1.0).toFixed(2)
      //SET NULL OR NaN = 0
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        amount = String(amount)
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
    }
  }
}
</script>

<style scoped>
.b {
  border-radius: 5px;
  padding: 5px;
  /* Add padding here */
  color: white;
  background-color: #792cffde;
}

.b-success {
  background-color: #03c837de;
}

.b-failed {
  background-color: #ff0000de;
}

.b-create {
  background-color: #ffb300de;
}
</style>
